// @ts-nocheck
import storeConstants from "@store/storeConstants";

interface InventoryStatus {
    inStockAmount: number;
    temporaryOutOfStockAmount: number;
    onDemandAmount: number;
    shouldShowInStock: boolean;
    shouldShowTemporaryOutOfStock: boolean;
    shouldShowOnDemand: boolean;
    shouldShowDiscontinued: boolean;
}

export const useInventoryStatus = (
    qtyOnHand: number | undefined,
    qtyOrdered: number | null | undefined,
    availabilityCode: string | undefined,
    whsQuantityOrdered: string | undefined,
): InventoryStatus => {
    const Whs_RealOnHandUnit = qtyOnHand ?? 0;
    const Whs_OrderedUnit = parseFloat(whsQuantityOrdered ?? "");
    const qty = qtyOrdered ?? 0;

    const shouldShowInStock = availabilityCode === "InStock";
    const shouldShowTemporaryOutOfStock =
        (availabilityCode === "InStock" && Whs_RealOnHandUnit < qty) ||
        (availabilityCode === "TemporaryOutofStock" && Whs_OrderedUnit + Whs_RealOnHandUnit > 0);

    const inStockAmount = shouldShowInStock ? Math.min(Whs_RealOnHandUnit, qty) : 0;
    let temporaryOutOfStockAmount = 0;

    if (shouldShowTemporaryOutOfStock) {
        if (Whs_RealOnHandUnit > 0) {
            if (qty <= Whs_OrderedUnit + Whs_RealOnHandUnit)
                temporaryOutOfStockAmount = Math.min(qty - Whs_RealOnHandUnit, Whs_OrderedUnit);
            else {
                temporaryOutOfStockAmount = Math.min(qty, Whs_OrderedUnit);
            }
        } else {
            temporaryOutOfStockAmount = Math.min(qty, Whs_OrderedUnit + Whs_RealOnHandUnit);
        }
    }

    const onDemandAmount =
        availabilityCode === "OnDemand" || Whs_OrderedUnit + Whs_RealOnHandUnit <= 0
            ? qty
            : Math.max(0, qty - (Whs_OrderedUnit + Whs_RealOnHandUnit));
    const shouldShowOnDemand =
        availabilityCode !== storeConstants.availabilityCodes.Discontinued &&
        (availabilityCode === "OnDemand" || onDemandAmount > 0);

    const shouldShowDiscontinued = availabilityCode === storeConstants.availabilityCodes.Discontinued;

    return {
        inStockAmount,
        temporaryOutOfStockAmount,
        onDemandAmount,
        shouldShowInStock,
        shouldShowTemporaryOutOfStock,
        shouldShowOnDemand,
        shouldShowDiscontinued,
    };
};
